import { combineReducers } from "redux";
import drawerSlice from "./slices/drawerSlice";
import navSectionSlice from "./slices/navSectionSlice";
import authSlice from "./slices/authSlice";
import headerSlice from "./slices/headerSlice";
import snackbarSlice from "./slices/snackbarSlice";
import backdropSlice from "./slices/backdropSlice";
import UserSlice from "./slices/UserSlice";
import companySlice from "./slices/companySlice";
import branchOfficeSlice from "./slices/branchOfficeSlice";
import storeSlice from "./slices/storeSlice";
import productAttributeSlice from "./slices/productAttributeSlice";
import ProductUsageAttributeSlice from "./slices/ProductUsageAttributeSlice";
import specificAttributesSlice from "./slices/specificAttributesSlice";
import categorySilce from "./slices/categorySilce";
import subcategorySlice from "./slices/subcategorySlice";
import productSlice from "./slices/productSlice";
import supplierSlice from "./slices/supplierSlice";
import listOfProductsSlice from "./slices/listOfProductsSlice";
import UbigeoSlice from "./slices/UbigeoSlice";
import documentOfSalesSlice from "./slices/documentOfSalesSlice";
import wayToPaySlice from "./slices/wayToPaySlice";
import specificSubcategorySlice from "./slices/specificSubcategorySlice";
import specificUsesSlice from "./slices/specificUsesSlice";
import priceListSlice from "./slices/priceListSlice";
import unitMeasureSlice from "./slices/unitMeasureSlice";
import bussinesAreaSlice from "./slices/bussinesAreaSlice";
import productClassificationSlice from "./slices/productClassificationSlice";
import typeProductSlice from "./slices/typeProductSlice";
import ProductImportSlice from "./slices/ProductImportSlice";
import segmentSlice from "./slices/segmentSlice";
import saleChannelSlice from "./slices/saleChannelSlice";
import sellerSlice from "./slices/sellerSlice";
import clientWalletSlice from "./slices/clientWalletSlice";
import priceListProductSlice from "./slices/priceListProductSlice";
import priceListBranchofficeSlice from "./slices/priceListBranchofficeSlice";
import priceListCustomerSlice from "./slices/priceListCustomerSlice";
import priceListSalesmanSlice from "./slices/priceListSalesmanSlice";
import priceListSegmentSlice from "./slices/priceListSegmentSlice";
import searcherSlice from "./slices/searcherSlice";
import shearchKFCSlice from "./slices/shearchKFCSlice";
import shoppingCartSlice from "./slices/shoppingCartSlice";
import ticketSlice from "./slices/ticketSlice";
import referenceDocumentSlice from "./slices/referenceDocumentSlice";
import stockProductsSlice from "./slices/stockProductsSlice";
import typeSaleSlice from "./slices/typeSaleSlice";
import permissionSlice from "./slices/permissionSlice";
import softnetSlice from "./slices/softnetSlice";
import administratorSlice from "./slices/administratorSlice";
import initialStepSlice from "./slices/initialStepSlice";
import planSlice from "./slices/planSlice";
import importSlice from "./slices/importSlice";
import typeAttributeSlice from "./slices/typeAttributeSlice";
import clientAdressSlice from './slices/clientAddressSlice';
import intakeCartSlice from './slices/intakeCartSlice';
import productEntrySlice from './slices/productEntrySlice';
import driverSlice from './slices/driverSlice';
import patentSlice from './slices/patentSlice';
import accountReceivableSlice from './slices/accountReceivableSlice'
import bankSlice from './slices/bankSlice'
import paymentVoucherSlice from './slices/paymentVoucherSlice'
import cartolaSlice from './slices/cartolaSlice'
import notificationSlice from './slices/notificationSlice'
import batchSlice from './slices/batchSlice'

const reducers = combineReducers({
    drawerSlice: drawerSlice,
    navSectionSlice: navSectionSlice,
    authSlice: authSlice,
    headerSlice: headerSlice,
    snackbarSlice: snackbarSlice,
    backdropSlice: backdropSlice,
    userSlice: UserSlice,
    companySlice: companySlice,
    branchOfficeSlice: branchOfficeSlice,
    storeSlice: storeSlice,
    productAttributeSlice: productAttributeSlice,
    typeAttributeSlice: typeAttributeSlice,
    ProductUsageAttributeSlice: ProductUsageAttributeSlice,
    specificAttributesSlice: specificAttributesSlice,
    categorySilce: categorySilce,
    subcategorySlice: subcategorySlice,
    productSlice: productSlice,
    supplierSlice: supplierSlice,
    listOfProductsSlice: listOfProductsSlice,
    UbigeoSlice: UbigeoSlice,
    documentOfSalesSlice: documentOfSalesSlice,
    wayToPaySlice: wayToPaySlice,
    specificSubcategorySlice: specificSubcategorySlice,
    specificUsesSlice: specificUsesSlice,
    priceListSlice: priceListSlice,
    unitMeasureSlice: unitMeasureSlice,
    bussinesAreaSlice: bussinesAreaSlice,
    productClassificationSlice: productClassificationSlice,
    typeProductSlice: typeProductSlice,
    ProductImportSlice: ProductImportSlice,
    segmentSlice: segmentSlice,
    saleChannelSlice: saleChannelSlice,
    sellerSlice: sellerSlice,
    clientWalletSlice: clientWalletSlice,
    priceListProductSlice: priceListProductSlice,
    priceListBranchofficeSlice: priceListBranchofficeSlice,
    priceListCustomerSlice: priceListCustomerSlice,
    priceListSalesmanSlice: priceListSalesmanSlice,
    priceListSegmentSlice: priceListSegmentSlice,
    searcherSlice: searcherSlice,
    shearchKFCSlice: shearchKFCSlice,
    shoppingCartSlice: shoppingCartSlice,
    ticketSlice: ticketSlice,
    referenceDocumentSlice: referenceDocumentSlice,
    stockProductsSlice: stockProductsSlice,
    typeSaleSlice: typeSaleSlice,
    permissionSlice: permissionSlice,
    softnetSlice: softnetSlice,
    adminSlice: administratorSlice,
    initialStepSlice: initialStepSlice,
    planSlice: planSlice,
    importSlice: importSlice,
    clientAdressSlice: clientAdressSlice,
    intakeCartSlice: intakeCartSlice,
    productEntrySlice: productEntrySlice,
    driverSlice: driverSlice,
    patentSlice: patentSlice,
    accountReceivableSlice: accountReceivableSlice,
    bankSlice: bankSlice,
    notificationSlice: notificationSlice,
    paymentVoucherSlice: paymentVoucherSlice,
    cartolaSlice: cartolaSlice,
    batchSlice: batchSlice,
});

export default reducers;
